let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("jY0Qv")).then(() => parcelRequire('4KF4k'));